
export function OnboardingDateDirective($interval, $timeout, $window) {
    'ngInject'

    return {
        selector: "apexDateFormat",
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.dateFormat = function (modelValue, viewValue) {
                // Check if the input value matches the desired date format (MM/DD/YYYY)
                if (viewValue && !/^\d{2}\/\d{2}\/\d{4}$/.test(viewValue)) {
                    return false; // Invalid format
                }
                return true; // Valid format
            };
        }
    };
}
